/**
 * ProductGridDetails
 * @description Web component used to show the details of a product, based op the active slide.
 */

(async () => {
  if (!customElements.get('productGridDetails')) {

    class ProductGridDetails extends HTMLElement {
      constructor() {
        super();

        // Parse the data from the script tag in the parent element
        this.productData = JSON.parse(this.querySelector('[type="application/json"]').textContent);


        // Listen to the swiper slide change event
        this.swiperEl = this.querySelector(`swiper-slider`);

        this.swiperEl.addEventListener('swiperSlideChange', (event) => {
          // Get the product id from the slide
          const slide = this.swiperEl.querySelectorAll(`[data-swiper-slide-index="${event.detail.activeIndex}"]`)[0];
          if (!slide) return;
          const productID = slide.dataset.productGridId;

          // Get the product data from the product id
          const productData = this.productData[productID];
          if (!productData) return;

          // Update the details
          this.updateDetails(productData);

          // Update the image compare slider
          this.imageCompareEl = this.imageCompareEl || this.querySelector('image-compare');
          this.imageCompareEl.resetSlider();
          if (productData.image_before && productData.image_after) {
            this.updateBeforeAfterImages(productData.image_before, productData.image_after);
            this.imageCompareEl.style.display = 'block';
          } else {
            this.imageCompareEl.style.display = 'none';
          }
        });
      }

      updateDetails(productData) {
        this.detailPanesWrapper = this.detailPanesWrapper || this.querySelector('[data-product-detail-panes]');
        this.detailPanes = this.detailPanes || this.detailPanesWrapper.querySelectorAll('[data-product-detail-pane]');
        this.mediaWrapper = this.mediaWrapper || this.detailPanesWrapper.querySelector('[data-product-detail-media]');
        this.detailTitle = this.detailTitle || this.detailPanesWrapper.querySelector('[data-product-detail-title]');
        this.detailTitle.innerHTML = productData.title;

        // Hide the detail panes if there are no details to show
        if (!productData.details.length && !productData.image_before && !productData.image_after) {
          this.detailPanesWrapper.style.display = 'none';
          return;
        } else {
          this.detailPanesWrapper.style.display = 'block';
        }

        // Update the details panes
        this.detailPanes.forEach((pane) => {
          const index = pane.dataset.productDetailPane;
          // hide this pane if there are no details to show
          if (productData.details[index] === undefined) {
            pane.innerHTML = '';
            pane.style.opacity = 0;
            return
          }
          // show the pane and set the innerHTML
          pane.innerHTML = productData.details[index];
          pane.style.opacity = 1;
        });

        // Update the media
        if (!this.mediaWrapper || !productData.media) {
          return;
        }

        // Hide the current image
        this.mediaWrapper.style.opacity = 0;

        // Extract the src URL from the HTML string for preloading
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = productData.media;
        const imgElement = tempDiv.querySelector('img');
        const imageUrl = imgElement ? imgElement.src : null;

        // preload the image if we have a valid URL
        if (imageUrl) {
          const img = new Image();
          img.src = imageUrl;
        }

        // Replace the image and show it
        this.mediaWrapper.innerHTML = productData.media;
        this.mediaWrapper.style.opacity = 1;
      }

      /*
       * Update the before and after images
       */
      updateBeforeAfterImages(image_before, image_after) {
        this.beforemediaWrapper = this.beforemediaWrapper || this.querySelector('[data-image-comparison-overlay="before"] picture');
        this.aftermediaWrapper = this.aftermediaWrapper || this.querySelector('[data-image-comparison-overlay="after"] picture');
        this.beforemediaWrapper.innerHTML = image_before;
        this.aftermediaWrapper.innerHTML = image_after;
      }
    }

    window.ProductGridDetails = ProductGridDetails;

    customElements.define('product-grid-details', ProductGridDetails);
  }
})();
